import { ConnectedRouter } from "connected-react-router";
import React from "react";
import { IntlProvider } from "react-intl";
import { connect, Provider as ReduxProvider } from "react-redux";
import { Context as MediaQueryContext } from "react-responsive";
import EdgeApiProvider from "../../universal/components/edge-api";
import FeatureFlagProviderWrapper from "./feature-flag-provider-wrapper";

const ConnectedIntlProvider = connect(state => ({
  locale: state.intl.locale,
  messages: state.intl.messages
}))(IntlProvider);

const ConnectedEdgeApiProvider = connect(state => ({
  baseUrl: state.paths.api,
  publicBaseUrl: state.paths.publicApi
}))(EdgeApiProvider);

const Providers = ({ history, store, children }) => {
  return (
    <ReduxProvider store={store}>
      <ConnectedIntlProvider>
        <FeatureFlagProviderWrapper>
          <ConnectedEdgeApiProvider>
            <MediaQueryContext.Provider>
              <ConnectedRouter history={history}>{children}</ConnectedRouter>
            </MediaQueryContext.Provider>
          </ConnectedEdgeApiProvider>
        </FeatureFlagProviderWrapper>
      </ConnectedIntlProvider>
    </ReduxProvider>
  );
};

Providers.propTypes = {};

export default Providers;
